import React from "react";
import { TableRow, TableCell } from "../../ui/table";
import { Button } from "../../ui/button";
import { Badge } from "../../ui/badge";
import { Check, X, Pencil } from "lucide-react";

/**
 * Referral Link User Row Component
 * Modernized with shadcn TableRow and TableCell
 */
function Users_no_row(props) {
    const { userName, firstName, lastName, email, groupNumber, userId, referral_Link_Request_Status } = props;

    if (!userName) {
        return (
            <TableRow>
                <TableCell colSpan={5} className="text-center py-8 text-brand-dark/70">
                    No Record Found
                </TableCell>
            </TableRow>
        );
    }

    // Render status badge
    const renderStatusBadge = () => {
        switch (referral_Link_Request_Status) {
            case "Requested":
                return <Badge variant="outline" className="bg-yellow-50 text-yellow-700 border-yellow-200">Requested</Badge>;
            case "Approved":
                return <Badge variant="outline" className="bg-green-50 text-green-700 border-green-200">Approved</Badge>;
            case "Rejected":
                return <Badge variant="outline" className="bg-red-50 text-red-700 border-red-200">Rejected</Badge>;
            default:
                return <Badge variant="outline">{referral_Link_Request_Status}</Badge>;
        }
    };

    // Render action buttons based on status
    const renderActions = () => {
        switch (referral_Link_Request_Status) {
            case "Requested":
                return (
                    <div className="flex items-center justify-end gap-2">
                        <Button
                            size="sm"
                            onClick={props.deactivate_refferals_links}
                            status="Approved"
                            numbering={userId}
                            username_={userName}
                            className="bg-green-600 hover:bg-green-700 text-white gap-1"
                        >
                            <Check className="h-4 w-4" />
                            Accept
                        </Button>
                        <Button
                            size="sm"
                            onClick={props.deactivate_refferals_links}
                            status="Rejected"
                            numbering={userId}
                            username_={userName}
                            className="bg-red-600 hover:bg-red-700 text-white gap-1"
                        >
                            <X className="h-4 w-4" />
                            Reject
                        </Button>
                    </div>
                );
            
            case "Approved":
                return (
                    <div className="flex items-center justify-end gap-2">
                        <Button
                            size="sm"
                            variant="ghost"
                            onClick={props.toggle_add_edit_popup}
                            nameeeee={userName}
                            ofcu={userId}
                            useremail={email}
                            userfirstname={firstName}
                            userlastname={lastName}
                            numbering={userId}
                            className="h-8 w-8 p-0"
                        >
                            <Pencil className="h-4 w-4" />
                        </Button>
                        <Button
                            size="sm"
                            variant="outline"
                            onClick={props.deactivate_refferals_links}
                            nameeeee={userName}
                            ofcu={userId}
                            status="Approvedbyadmin"
                            numbering={userId}
                            username_={userName}
                            className="text-red-600 hover:text-red-700 hover:bg-red-50"
                        >
                            Disable Referral Links
                        </Button>
                    </div>
                );
            
            case "Rejected":
                return (
                    <div className="flex items-center justify-end">
                        <Button
                            size="sm"
                            onClick={props.deactivate_refferals_links}
                            status="Approved"
                            numbering={userId}
                            username_={userName}
                            className="bg-green-600 hover:bg-green-700 text-white gap-1"
                        >
                            <Check className="h-4 w-4" />
                            Accept
                        </Button>
                    </div>
                );
            
            default:
                return null;
        }
    };

    return (
        <TableRow className="hover:bg-brand-light-1/30">
            <TableCell className="font-medium text-brand-dark">
                {firstName} {lastName}
            </TableCell>
            <TableCell className="text-brand-dark/80">
                {groupNumber}
            </TableCell>
            <TableCell className="text-brand-dark/80">
                {email}
            </TableCell>
            <TableCell>
                {renderStatusBadge()}
            </TableCell>
            <TableCell className="text-right">
                {renderActions()}
            </TableCell>
        </TableRow>
    );
}

export default Users_no_row;
